cb.define([], function () {

    var PM_pmc_couponref_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            var gridModel = viewmodel.getGridModel();
            var params = viewmodel.getParams();
            gridModel.setReadOnly(false);
            //获取参数中的价格,数量,并重置
            gridModel.on("beforeSetDataSource", function (data) {
                if (params.couponids && params.couponids != "") {
                    let ids = params.couponids.split(",");
                    let nums = params.couponnums.split(",");
                    for (let i = 0; i < ids.length; i++) {
                        for (let j = 0; j < data.length; j++) {
                            if (data[j].id == ids[i] && nums[i] && nums[i] != "") {
                                data[j].amount = nums[i];
                            }
                        }
                    }
                }
            });
            viewmodel.on('sure', function () {
                let customizedOrder = viewmodel.get('pmc_couponref').getSelectedRows();

                viewmodel.execute('sure1', customizedOrder);
            });
            viewmodel.on('couponclose', function () {
                viewmodel.execute('promotionabandon');
            });

            viewmodel.getGridModel().getEditRowModel().get('amount').setState('min', 0);
        }
    };
    try {
        module.exports = PM_pmc_couponref_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_couponref_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_couponref_VM.Extend.js